import ImgDefault from "../assets/svg/profileImg/profileImg.svg";
import ImgDefaultHover from "../assets/svg/profileImg/profileImgHover.svg";
import IconEdit from "../assets/svg/pen-icon-account.svg";
import IconDelete from "../assets/svg/icon-delete-show-account.svg";
import plus from "../assets/svg/profileImg/plus.svg";
import {apiUpdateProfile} from "../api/appApi";

export const profileFormData = {
    key: "person",
    title: "شخص",
    addFunction: apiUpdateProfile,
    navigation: {
        title: "تنظیمات",
        description: "مدیریت اطلاعات حساب کاربری",
        backTitle: null,
        backUrl: null,
    },
    tabs: [
        {
            key: "customer",
            name: "ویرایش پروفایل ",
            form: {
                main: {
                    wrapperClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7",
                    imagePicker: {
                        active: true,
                        type: "imagePicker",
                        name: "file",
                        wrapperClass: "col-lg-5 col-md-5 col-sm-5 col-xs-12",
                        defaultImage: ImgDefault,
                        defaultImageHover: ImgDefaultHover,
                        editTitle: "انتخاب عکس",
                        editIcon: IconEdit,
                        deleteTitle: "حذف",
                        deleteIcon: IconDelete,
                        addIcon: plus,
                    },
                    inputs: [
                        {
                            wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12",
                            name: "firstName",
                            label: "نام ",
                            maxLength: 64,
                            primary: true,
                            required: true,
                        },
                        {
                            wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12",
                            name: "lastName",
                            label: "نام خانوادگی ",
                            maxLength: 64,
                            primary: true,
                            required: true,
                        },
                        {
                            wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
                            name: "email",
                            label: "ایمیل ",
                            type: "price",
                            maxLength: 64,
                            primary: true,
                        },
                        {
                            wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
                            name: "phone",
                            label: "تلفن همراه ",
                            maxLength: 64,
                            primary: true,
                        },
                        {
                            wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
                            type: "descriptionFields",
                            description:
                                "در صورت تغییر ایمیل یا تلفن همراه، نیاز به تایید مجدد اطلاعات و ورود دوباره به حساب کاربری خود خواهید داشت.",
                        },
                        {
                            wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
                            type: "button",
                            label: "ذخیره تغییرات",
                            width: "50%",
                            requestingApi: "updateProfile",
                            action: apiUpdateProfile,
                        },
                    ],
                },
            },
        },
    ],
};
